define.alias("shared/components/shared/publish/switcher/item/info-text", "preview-grid/components/shared/publish/switcher/item/info-text");